import { useStoreModel } from './model';
import { StoreView } from './view';
import { PageTransition } from '@/shared/components/transitions/page-transition';
import { useNavigation } from '@/shared/contexts/navigation-context';

export default function StoreViewModel() {
  const methods = useStoreModel();
  const { direction } = useNavigation();

  return (
    <PageTransition direction={direction}>
      <StoreView {...methods} />
    </PageTransition>
  );
}
